import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { LoadingController, ModalController, ToastController } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { WhatsappService } from 'src/app/services/whatsapp.service';
import { ValidarToken } from 'src/app/validators/valida-datos';

@Component({
  selector: 'app-mdl-chats-bot',
  templateUrl: './mdl-chats-bot.page.html',
  styleUrls: ['./mdl-chats-bot.page.scss'],
})
export class MdlChatsBotPage implements OnInit {

  @Input() idAdmin: string;
  @Input() numero: any;
  @Input() inicio: any;
  @Input() fin: any;
  loading: any;
  chat: any;
  arrConver: any;
  classUser: any;
  canal: any;
  canales: any;
  canalInicial: any;
  constructor(
    private serviceWa: WhatsappService,
    private loadingController: LoadingController,
    private toastCtrl: ToastController,
    private modal: ModalController,
    private formatdate: DatePipe,
    private storage: Storage
  ) { 
    this.canales = [];
  }

  ngOnInit() {
    this.classUser = new ValidarToken(this.storage);
    this.chat = [];
    this.arrConver = [];
    this.presentLoading('Cargando chat...');
    setTimeout(() => {
      this.getCanal();
      
    }, 500);
  }

  async getCanal() {
    this.canal = await this.storage.get('canal').then();
    this.canales = await this.storage.get('canales').then();
      // console.log(this.canales, 'canales ');
      this.canalInicial = this.canales.find(canal => canal.canale.idAdmin_sec == this.canal.idAdmin_sec);
      this.idAdmin = this.canalInicial.canale.idAdmin_sec;
      this.classUser = this.canalInicial;
      this.getChat();
    // console.log(this.canal.url_back, 'url de back desde storage');
  }

  getChat() {
    const query = {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      idAdmin: this.idAdmin,
      numero: this.numero
    };
    let fechas = '';
    if (this.inicio) {
      fechas = `?fechaI=${this.inicio}&fechaF=${this.fin}`;
    }
    // console.log(fechas, query);
    this.serviceWa.getChatBot(query, fechas, this.classUser.id, this.classUser.rol, this.classUser.token, this.classUser.canale.url_back).subscribe(
      (res: any)=>{
      // console.log(res);
      this.loading.dismiss();

        const { status, message } = res;
        if (status === 'success') {
          const { chats } = res;
          this.chat = chats;
          //  this.formatTable(this.chat);
          //  console.log(this.conversaciones);
          this.presentToast('Datos encontrados!', 'success');
        }
        else {
          this.presentToast('No se encontrarón conversaciones', 'danger');
        }
      },
      erro => {
        console.log(erro);
        this.loading.dismiss();
      });
  }

  back() {
    this.modal.dismiss();
  }

  // formatTable(conversaciones) {
  //   this.arrConver = conversaciones.map((conver) =>( {
  //       // eslint-disable-next-line @typescript-eslint/naming-convention
  //       Telefono: this.cliente,
  //       // eslint-disable-next-line @typescript-eslint/naming-convention
  //       Nombre: this.nombreCliente,
  //       // eslint-disable-next-line @typescript-eslint/naming-convention
  //       'Fecha de Envio': this.formatdate.transform(conver.createdAt, 'dd/MM/yyyy HH:mm:ss'),
  //       // eslint-disable-next-line @typescript-eslint/naming-convention
  //       Mensaje: conver.mensaje,
  //       // eslint-disable-next-line @typescript-eslint/naming-convention
  //       Agente: this.agente,
  //       // eslint-disable-next-line @typescript-eslint/naming-convention
  //       'Enviado por': conver.autor,
  //   }));
  // }

  // descargar() {
  //   this.serviceWa.exportAsExcelFile(this.arrConver, `chat-${this.cliente}-${this.agente}-${this.formatdate.transform(new Date(),
  //     'dd-MM-yyyy-HH-mm-ss')}`);
  // }

  async presentLoading(mensaje) {
    this.loading = await this.loadingController.create({
      spinner: 'dots',
      message: mensaje,
    });
    await this.loading.present();
  }

  async presentToast(message, color) {
    const toast = await this.toastCtrl.create({
      message,
      duration: 3000,
      color
    });
    toast.present();
  }

}
